import Vue from "vue";
import { toDateString,toPrettyDateTimeString, humanFloat } from "./strings";

Vue.filter("dateString", toDateString);
Vue.filter("prettyDateTimeString", toPrettyDateTimeString);
Vue.filter("humanFloat", humanFloat);